/* eslint-disable @typescript-eslint/naming-convention */

import React from 'react';

import { useGql2Loader } from '@search/gql-client/src/useGql2';
import { useGqlContext } from '@search/gql-client/src';
import PlacementOfferQuery from './gql/PlacementOfferQuery';
import type {
    PlacementOfferQuery$variables as PlacementOfferQueryVariables,
    PlacementOfferQuery$data as PlacementOfferQueryResponse
} from './gql/__generated__/PlacementOfferQuery.graphql';

interface Props {
    userId?: string;
    offerId?: string;
    ownerId?: string | null;
}

function usePlacementOfferFetcher() {
    const gql = useGqlContext();

    return React.useCallback(
        (vars: PlacementOfferQueryVariables, opts?: { signal?: AbortSignal }) => gql.client<
            PlacementOfferQueryVariables,
            PlacementOfferQueryResponse
            >(PlacementOfferQuery, vars, opts).then(),
        [ gql ]
    );
}

export const usePlacementOffer = ({ userId, offerId, ownerId }: Props) => {
    if (userId && ownerId && offerId && userId === ownerId) {
        const placementOfferLoader = useGql2Loader(
            usePlacementOfferFetcher(),
            { cachePrefix: 'placementOfferCl' }
        );

        const { data, loading } = placementOfferLoader({ userId, offerId });

        return {
            placementOffer: data?.getPlacementOffer?.item?.offer,
            isLoading: loading,
            showStats: true
        };
    }
    return {
        placementOffer: null,
        isLoading: false,
        showStats: false
    };
};
